import { create } from 'zustand';

const initialOverlay = {
    open: false,
    type: null,
    payload: null
};

function getOverlayPosition() {
    try {

        const saved = localStorage.getItem('overlayPosition');

        return saved
            ? JSON.parse(saved)
            : {
                centerOffsetX: 0,
                centerOffsetY: 0
            };

    } catch {

        return {
            centerOffsetX: 0,
            centerOffsetY: 0
        };

    }
}

function saveOverlayPosition(overlayPosition) {

    try {

        localStorage.setItem(
            'overlayPosition',
            JSON.stringify(overlayPosition)
        );

    } catch {}

}

function getOverlayPreferredScreen() {

    try {

        const saved = localStorage.getItem('overlayPreferredScreen');

        return saved
            ? saved
            : 'Home'

    } catch {

        return 'Home';

    }

}

function saveOverlayPreferredScreen(screen) {

    try {

        localStorage.setItem('overlayPreferredScreen', screen);

    } catch {}

}

const initialOverlayPosition = getOverlayPosition();
const initialPreferredScreen = getOverlayPreferredScreen();

export const useOverlayStore = create((set, get) => ({

    canClose: true,

    overlay: initialOverlay,

    setCanClose: (canClose) => {
        set({ canClose });
    },

    openOverlay: ({
        type,
        payload = null
    }) => {

        set({
            overlay: {
                open: true,
                type,
                payload
            }
        });

    },

    closeOverlay: () => {

        if (!get().canClose) {
            return;
        }

        set({
            overlay: initialOverlay
        });

    },

    syncOverlay: (open, overlay) => {

        if (!open) {
            get().closeOverlay();
            return;
        }

        set({
            overlay: {
                open: true,
                type: overlay.type,
                payload: overlay.payload
            }
        });

    },

    applyMove: (preferredScreen, overlay) => {
        set({
            preferredScreen,
            overlay
        });
    },

    overlayPosition: initialOverlayPosition,
    preferredScreen: initialPreferredScreen,

    setOverlayPosition: ({ centerX, centerY }) => {

        const overlayPosition = {
            centerOffsetX: centerX - window.innerWidth / 2,
            centerOffsetY: centerY - window.innerHeight / 2
        };

        saveOverlayPosition(overlayPosition);

        set({ overlayPosition });

    },

    setPreferredScreen: (preferredScreen) => {

        saveOverlayPreferredScreen(preferredScreen);

        set({ preferredScreen });

    }

}));